import { useNavigate } from "react-router-dom";

import { Models } from "api/types";

export const InclusionDetails = ({
  typedItem,
  inclusionType,
  isFreePackageGroup = false,
  disableNavigation = false,
}: {
  typedItem: Models<"InclusionModel">;
  inclusionType: string;
  isFreePackageGroup?: boolean;
  disableNavigation?: boolean;
}) => {
  const navigate = useNavigate();
  const navigationPath =
    inclusionType === "treatments" ||
    inclusionType === "packages" ||
    inclusionType === "products"
      ? "/pdp/package/"
      : "/pdp/membership/";

  // Check if this is a treatment/product with variants
  const treatmentItem = typedItem as Models<"TreatmentInclusionModel">;
  const hasVariants =
    (inclusionType === "treatments" || inclusionType === "products") &&
    treatmentItem.variants &&
    treatmentItem.variants.length > 0 &&
    !treatmentItem.allVariants;

  // For free package groups with quantity
  const quantityText =
    isFreePackageGroup && typedItem.quantity?.value
      ? ` (${typedItem.quantity.value} ${
          typedItem.quantity.value < 2
            ? typedItem.quantity.unitType.singularUnitType
            : typedItem.quantity.unitType.pluralUnitType
        })`
      : "";

  return (
    <li>
      {isFreePackageGroup || disableNavigation ? (
        <div className="py-[1px] pl-5">
          {typedItem.name}
          {hasVariants && (
            <span className="text-secondary">
              {" "}
              ({treatmentItem.variants.map((v) => v.name).join(", ")})
            </span>
          )}
          {quantityText}
        </div>
      ) : (
        <div className="py-[1px] pl-5 text-left">
          <button
            onClick={() => navigate(navigationPath + typedItem.id)}
            className="cursor-pointer border-b border-dotted border-brand-color text-brand-color hover:border-solid"
            aria-label={`Navigate to ${typedItem.name}`}
          >
            {typedItem.name}
          </button>
          {hasVariants && (
            <span className="text-secondary">
              {" "}
              ({treatmentItem.variants.map((v) => v.name).join(", ")})
            </span>
          )}
          {quantityText}
        </div>
      )}
    </li>
  );
};
